import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ComponentTitle from '../../../components/ComponentTitle/ComponentTitle'
import CaseStudiesMobile from '../CaseStudiesMobile/CaseStudiesMobile'

import useWindowDimension from '../../../hooks/useWindowDimension'

import pashaLogo from '../../../resources/images/pasha-icon.svg'

import {
	FinancialServiceSvg,
	GamblingSvg,
	HealthyCareSvg,
	MobilityAndTravelSvg,
	RetailAndCommerceSvg,
	SharingEconomySvg,
	TeleCommunicationSvg,
	EducationSvg
} from '../../../resources/SvgComponents/CaseStudies'

import {
	StyledContainer,
	StyledTitleContainer,
	StyledMainContainer,
	StyledGroupInner,
	StyledInnerContainer,
	StyledInnerSideBar,
	StyledLi,
	StyledInnerImageContainer,
	StyledLogoContainer,
	StyledDescriptionContainer,
	StyledEffectDescription,
	StyledInnerTitle
} from './CaseStudiesStyle'

const images = {
	financialService: <FinancialServiceSvg />,
	gambling: <GamblingSvg />,
	teleCommunication: <TeleCommunicationSvg />,
	retailAndCommerce: <RetailAndCommerceSvg />,
	sharingEconomy: <SharingEconomySvg />,
	education: <EducationSvg />,
	mobilityAndTravel: <MobilityAndTravelSvg />,
	healthyCare: <HealthyCareSvg />
}

const logo = {
	financialService: pashaLogo,
	gambling: '',
	teleCommunication: '',
	retailAndCommerce: '',
	sharingEconomy: '',
	education: '',
	mobilityAndTravel: '',
	healthyCare: ''
}

const description = {
	financialService: 'financialServiceDescription',
	gambling: 'gamblingDescription',
	teleCommunication: 'teleCommunicationDescription',
	retailAndCommerce: 'retailAndCommerceDescription',
	sharingEconomy: 'sharingEconomyDescription',
	education: 'educationDescription',
	mobilityAndTravel: 'mobilityAndTravelDescription',
	healthyCare: 'healthyCareDescription'
}
const effect = {
	financialService: 'financialServiceEffect',
	gambling: 'gamblingEffect',
	teleCommunication: 'teleCommunicationEffect',
	retailAndCommerce: 'retailAndCommerceEffect',
	sharingEconomy: 'sharingEconomyEffect',
	education: 'educationEffect',
	mobilityAndTravel: 'mobilityAndTravelEffect',
	healthyCare: 'healthyCareEffect'
}

const CaseStudies = ({ active: activeTab }) => {
	const { t } = useTranslation()
	const [active, setActive] = useState('gambling')
	const [animation, setAnimation] = useState(false)

	const timer = useRef()

	useEffect(() => {
		activeTab ? setActive(activeTab) : setActive('gambling')
	}, [activeTab])

	const onActiveChange = title => {
		if (title === active) {
			setActive('gambling')
		} else {
			setActive(title)
		}
	}

	const handleAnimationChange = () => {
		if (animation) {
			clearTimeout(timer.current)
			timer.current = setTimeout(() => setAnimation(state => !state), 300)
			setAnimation(false)
			setAnimation(true)
		} else {
			timer.current = setTimeout(() => setAnimation(state => !state), 300)
			setAnimation(true)
		}
	}

	const showHideAnimation = title => {
		onActiveChange(title)
		handleAnimationChange()
	}
	const { windowSize } = useWindowDimension()
	return (
		<>
			{windowSize.width > 960 && (
				<StyledContainer id={`industries`}>
					<StyledMainContainer>
						<StyledTitleContainer>
							<ComponentTitle value='useCasesTitle' />
							{/* <Description
            value={"caseStudiesDescription"}
            textColor="#ADAEB6"
            textMaxWidth="596px"
            center
          /> */}
						</StyledTitleContainer>
						<StyledInnerSideBar>
							<StyledLi 
								active={active === 'gambling'} 
								onClick={() => showHideAnimation('gambling')}
							>
								{t('gambling')}
							</StyledLi>
							<StyledLi
								active={active === 'financialService'}
								onClick={() => showHideAnimation('financialService')}
							>
								{t('financialService')}
							</StyledLi>
							<StyledLi
								active={active === 'teleCommunication'}
								onClick={() => showHideAnimation('teleCommunication')}
							>
								{t('teleCommunication')}
							</StyledLi>
							<StyledLi
								active={active === 'retailAndCommerce'}
								onClick={() => showHideAnimation('retailAndCommerce')}
							>
								{t('retailAndCommerce')}
							</StyledLi>
							<StyledLi active={active === 'sharingEconomy'} onClick={() => showHideAnimation('sharingEconomy')}>
								{t('sharingEconomy')}
							</StyledLi>
							<StyledLi active={active === 'education'} onClick={() => showHideAnimation('education')}>
								{t('education')}
							</StyledLi>
							<StyledLi
								active={active === 'mobilityAndTravel'}
								onClick={() => showHideAnimation('mobilityAndTravel')}
							>
								{t('mobilityAndTravel')}
							</StyledLi>
							<StyledLi active={active === 'healthyCare'} onClick={() => showHideAnimation('healthyCare')}>
								{t('healthyCare')}
							</StyledLi>
						</StyledInnerSideBar>
						<StyledInnerContainer>
							<StyledGroupInner animation={animation}>
								<StyledLogoContainer>
									{logo[active] && <>{<img src={logo[active]} alt='' />}</>}
								</StyledLogoContainer>
								<StyledDescriptionContainer>{t(description[active])}</StyledDescriptionContainer>
								<StyledEffectDescription>
									{effect[active] && (
										<>
											<StyledInnerTitle>{t('effectTitle')}</StyledInnerTitle>
											{t(effect[active])}
										</>
									)}
								</StyledEffectDescription>
							</StyledGroupInner>
							<StyledInnerImageContainer animation={animation}>{images[active]}</StyledInnerImageContainer>
						</StyledInnerContainer>
					</StyledMainContainer>
				</StyledContainer>
			)}
			{windowSize.width < 960 && <CaseStudiesMobile />}
		</>
	)
}

export default CaseStudies
